import { container, singleton } from "tsyringe";

import { Config } from "../config";
import { WebRTCsdkService } from './webrtcsdk-service';



export const enum SettingsKey {
  disableVideoOnGuestEnter = "disableVideoOnGuestEnter",
  muteMicOnGuestEnter = "muteMicOnGuestEnter",
  shareByModeratorOnly = "shareByModeratorOnly",

  echoCancellation = "echoCancellation",
  stereoInput = "stereoInput",
  autoGain = "autoGain",
  manualGain = "manualGain",

  automaticAddStreamSharedScreen = "automaticAddStreamSharedScreen",
  showAdvancedSettings = "showAdvancedSettings",
  shiftVideosUp = "shiftVideosUp",
  playSoundFx ="playSoundFx",

  cameraBlurActive = "cameraBlurActive",
  cameraBlurRange = "cameraBlurRange",
  cameraVirtualBgActive = "cameraVirtualBgActive",

}

@singleton()
export class SettingService {

  public settings = undefined;

  constructor() {

    this.settings = {
      disableVideoOnGuestEnter : false,
      muteMicOnGuestEnter      : true,
      shareByModeratorOnly     : false,
      echoCancellation         : false,
      stereoInput              : false,
      autoGain                 : false,
      manualGain               : 10,
      automaticAddStreamSharedScreen : true,
      shiftVideosUp            : true,
      showAdvancedSettings     : false,
      playSoundFx              : true,
      cameraBlurActive         : false,
      cameraBlurRange          : 5,
      cameraVirtualBgActive    : false,
    };

    try {
      // get settings checked state from localStorage
      const lsSettings = localStorage.getItem('settingsState');
      if (lsSettings) {
        const settings = JSON.parse(lsSettings);
        if (typeof settings === 'object') {
          this.settings = settings;
        } else {
          // init value in local storage
          localStorage.setItem('settingsState', JSON.stringify(this.settings));
        }
      } else {
        // init value in local storage
        localStorage.setItem('settingsState', JSON.stringify(this.settings));
      }
    } catch (e) {
      localStorage.setItem('settingsState', JSON.stringify(this.settings));
    }
    // reset some default
    this.settings.cameraBlurActive = false;
    this.settings.cameraVirtualBgActive = false;
  }

  getSetting(key) {
    if (typeof this.settings[key] !== 'undefined') {
      return this.settings[key];
    }
    return false;
  }

  setSetting(key, value) {
    this.settings[key] = value;
    localStorage.setItem('settingsState', JSON.stringify(this.settings));
  }

}
